'use client';

import React, { forwardRef, useCallback } from 'react';
import { Phone } from 'lucide-react';
import { Input, type InputProps } from '@/components/ui/generics/inputs/input/Input';
import { formatPhone } from '@/lib/format';

export interface PhoneInputProps extends Omit<InputProps, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
}

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ value, onChange, ...props }, ref) => {
    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value.replace(/\D/g, '').slice(0, 11);
        const formatted = formatPhone(raw);
        onChange(formatted);
      },
      [onChange],
    );

    return (
      <Input
        ref={ref}
        type="tel"
        inputMode="numeric"
        value={value}
        onChange={handleChange}
        placeholder="(00) 00000-0000"
        prefixIcon={<Phone className="w-4 h-4" />}
        maxLength={16}
        {...props}
      />
    );
  },
);

PhoneInput.displayName = 'PhoneInput';
